(function ($, njm) {
    'use strict';

    njm.views.homehero = Backbone.View.extend({

        events: {
           
        },

        /**
         * Initialize
         */
        initialize: function () {
            var $this = this;
			this.quoteComponent = $('.comp-tab-quote');
			
			this.quoteComponent.on({
				click: function(event) {
                    $this.selectBackground(event);
				}
			});
        },
		
		/***
         * Switch image on tab selection
         */
		selectBackground: function(event) {
			var category = $(event.target).attr('data-category'),
				media = $('.comp-homehero .media.desktop');

			if ( category !== undefined && $('.comp-homehero .media.desktop[data-category="' + category + '"]').length === 1 ) {
				media.each(function(){
					if ($(this).attr('data-category') === category) {
						$(this).fadeIn();
					} else {
						$(this).fadeOut();
					}
				});
			}
		}
    });
})(jQuery, njm);
